import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const sectionInnerBlockDefaultVariants = {}
const sectionInnerBlockCompoundVariants = []

const sectionInnerBlockSlotNames = [
  [
    "root",
    "section-inner-block__root"
  ]
]
const sectionInnerBlockSlotFns = /* @__PURE__ */ sectionInnerBlockSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, sectionInnerBlockDefaultVariants, getSlotCompoundVariant(sectionInnerBlockCompoundVariants, slotName))])

const sectionInnerBlockFn = memo((props = {}) => {
  return Object.fromEntries(sectionInnerBlockSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const sectionInnerBlockVariantKeys = []
const getVariantProps = (variants) => ({ ...sectionInnerBlockDefaultVariants, ...compact(variants) })

export const sectionInnerBlock = /* @__PURE__ */ Object.assign(sectionInnerBlockFn, {
  __recipe__: false,
  __name__: 'sectionInnerBlock',
  raw: (props) => props,
  variantKeys: sectionInnerBlockVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, sectionInnerBlockVariantKeys)
  },
  getVariantProps
})